import Swiper from "swiper";
import { A11y, Autoplay, Navigation, Scrollbar } from "swiper/modules";
import "@/styles/components/slider.css";
import "./photo-gallery-slider.css";

document.querySelectorAll(".element-photogalleryslider.as-scrollbar").forEach((el) => {
  const container = el.querySelector(".swiper");
  const numSlides = el.querySelectorAll(".swiper-slide").length;

  new Swiper(container, {
    modules: [A11y, Autoplay, Scrollbar],
    slidesPerView: 1.5,
    centeredSlides: numSlides > 1,
    centerInsufficientSlides: true,
    spaceBetween: 16,
    loop: numSlides > 3,
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
    },
    speed: 750,
    freeMode: true,
    scrollbar: {
      el: el.querySelector(".swiper-scrollbar"),
      draggable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2.5,
        spaceBetween: 24,
        centeredSlides: numSlides > 2,
        centerInsufficientSlides: true,
        loop: numSlides > 3,
      },
      1280: {
        slidesPerView: 3.5,
        spaceBetween: 24,
        centeredSlides: numSlides > 4,
        centerInsufficientSlides: true,
        loop: numSlides > 4,
      },
      1536: {
        slidesPerView: 4.5,
        spaceBetween: 24,
        centeredSlides: numSlides > 5,
        centerInsufficientSlides: true,
        loop: numSlides > 5,
      },
    },
  });
});

document.querySelectorAll(".element-photogalleryslider.as-arrows").forEach((el) => {
  const container = el.querySelector(".swiper");
  const numSlides = el.querySelectorAll(".swiper-slide").length;

  new Swiper(container, {
    modules: [A11y, Autoplay, Navigation],
    slidesPerView: 1.5,
    centeredSlides: numSlides > 1,
    centerInsufficientSlides: true,
    loop: numSlides > 3,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
    },
    speed: 750,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
    breakpoints: {
      768: {
        slidesPerView: 2.5,
        centeredSlides: numSlides > 2,
        centerInsufficientSlides: true,
        loop: numSlides > 3,
      },
      1024: {
        slidesPerView: 3.5,
        centeredSlides: numSlides > 3,
        centerInsufficientSlides: numSlides < 4,
        loop: numSlides > 4,
      },
      1536: {
        slidesPerView: 4.5,
        centeredSlides: numSlides > 3,
        centerInsufficientSlides: numSlides < 6,
        loop: numSlides > 5,
      },
    },
  });
});
